export function AthenaLogo({ color = "#06AED5", size = 24 }) {
  return (
    <div style={{ width: size, height: size }}>
      <svg
        viewBox="0 0 64 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.6704 9.57601L8.82915 2.31697C4.97935 0.750608 0.720267 3.58783 1.23367 7.71225C2.67782 19.3138 8.00773 27.0836 22.9736 27.059H26.6502L23.6061 34.042C23.1162 35.1658 23.3962 36.494 24.3707 37.2378C29.7642 41.3543 34.5154 41.353 39.8416 37.2337C40.8025 36.4906 41.0766 35.1756 40.5951 34.0605L37.5718 27.059H41.0766C55.4297 27.0017 61.1177 19.5771 62.758 7.76791C63.3321 3.63492 59.0667 0.767467 55.2017 2.33999L37.5193 9.53426L38.1414 7.48282C38.4092 6.59963 38.239 5.63005 37.6257 4.94039C33.7529 0.585389 30.3656 0.587742 26.5422 4.94745C25.9401 5.63398 25.7742 6.59262 26.0369 7.46716L26.6704 9.57601Z"
          fill={color}
        />
      </svg>
    </div>
  );
}
